var modules_5f96f03e = {"container":"_1lbh4xx","checked":"_mh0wfk","control":"_1nkqlre","disabled":"_ynugkb","read-only":"_ppad97","input":"_1c1a3u1","handler":"_19h2h0p","label":"_1nzw6am"};
import "../../../assets/7i8hpQVF.css";

export { modules_5f96f03e as default };
//# sourceMappingURL=Switch.module.less.js.map
